import { CountUp } from 'countup.js';

const counters = document.querySelectorAll('[data-counter]');

counters.forEach(counter => {
  const rawValue = counter.getAttribute('data-counter');
  const hasPlus = rawValue.includes('+');
  const hasPercent = rawValue.includes('%');

  const numericValue = parseFloat(rawValue.replace(/[+%]/g, ''));
  let suffix = '';
  if (hasPlus) suffix += '+';
  if (hasPercent) suffix += '%';

  const countUp = new CountUp(counter.id, numericValue, {
    duration: 2,
    decimalPlaces: numericValue % 1 !== 0 ? 1 : 0,
    enableScrollSpy: true,
    scrollSpyOnce: true,
    useGrouping: true,
    separator: ',', // comma for thousands
    suffix: suffix,
  });

  if (!countUp.error) {
    countUp.start();
  } else {
    console.error(countUp.error);
  }
});
